import { useEffect } from 'react';

interface JsonLdProps {
  /** Distinguishes this block from any other on the page. */
  id: string;
  /** Memoise at the call site — a new object each render remounts the tag. */
  data: object;
}

/**
 * A `application/ld+json` block in the document head.
 *
 * The site-wide Organization and WebSite data is static and lives in
 * public/index.html, where it needs no JavaScript to be found. This is for the
 * pages that only know what they describe once their data has loaded.
 */
export const JsonLd: React.FC<JsonLdProps> = ({ id, data }) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = id;
    // A "<" inside any string value would otherwise be able to close this very
    // tag; escaped, it is still valid JSON and still read as "<".
    script.text = JSON.stringify(data).replace(/</g, '\\u003c');
    document.head.appendChild(script);

    return () => {
      script.remove();
    };
  }, [id, data]);

  return null;
};
